/**
 * Lógica pura del panel «Restringir acceso» (spec 2026-10-07 §3).
 *  - Filas: los vinculados de la empresa (Usuarios[], la lista de Clientes),
 *    nunca root (cuando su rol se pudo leer; si no se pudo, se lista: el motor
 *    no le aplica restricciones a root de todos modos).
 *  - Una restricción heredada de una carpeta superior sale marcada y
 *    bloqueada: «Restringido desde ‹nombre›».
 *  - Se guarda la lista FINAL de uids del doc de ESTA carpeta; lo que el doc
 *    tenga y el panel no muestre (p. ej. alguien desvinculado después) se
 *    conserva: el panel no toca lo que no muestra.
 */
import { collectionPathOfEntry } from './folder_chain';
import { ownRestriction, restrictedSourceFor } from './folder_restrictions';

export const namesByPath = ({ routes, folder }) => {
  const m = new Map();
  (Array.isArray(routes) ? routes : []).forEach((r) => {
    const cp = r && r.entry && r.entry.reference ? collectionPathOfEntry(r.entry.reference) : null;
    if (cp) m.set(cp, r.name || r.entry.name || cp);
  });
  const own = folder && folder.reference ? collectionPathOfEntry(folder.reference) : null;
  if (own) m.set(own, folder.name || own);
  return m;
};

export const restrictRows = ({ users, collectionPath, restrictions, rolesByUid, names }) => {
  const seen = new Set();
  const own = ownRestriction(collectionPath, restrictions);
  return (Array.isArray(users) ? users : []).reduce((out, u) => {
    const uid = u && u.reference && u.reference.id;
    if (!uid || seen.has(uid)) return out;
    seen.add(uid);
    const role = rolesByUid ? rolesByUid.get(uid) : null;
    if (role && role.documents && role.documents.root === true) return out;
    const src = restrictedSourceFor(collectionPath, uid, restrictions);
    out.push({
      uid,
      email: u.email || uid,
      own: !!(own && own.uids.includes(uid)),
      lockedFrom: src ? ((names && names.get(src)) || 'una carpeta superior') : null,
    });
    return out;
  }, []);
};

export const restrictDiff = ({ rows, checked, collectionPath, restrictions }) => {
  const own = ownRestriction(collectionPath, restrictions);
  const before = new Set(own ? own.uids : []);
  const shown = new Set(rows.map((r) => r.uid));
  const isOn = (r) => (r.lockedFrom ? r.own : checked.has(r.uid));
  const final = new Set([...before].filter((u) => !shown.has(u)));
  rows.forEach((r) => { if (isOn(r)) final.add(r.uid); });
  const added = rows.filter((r) => isOn(r) && !before.has(r.uid));
  const removed = rows.filter((r) => !isOn(r) && before.has(r.uid));
  return {
    uids: [...final].sort(),
    added: added.map((r) => r.email),
    removed: removed.map((r) => r.email),
    addedUids: added.map((r) => r.uid),
    removedUids: removed.map((r) => r.uid),
    changed: added.length > 0 || removed.length > 0,
  };
};

export const confirmText = ({ added, subfolders }) => {
  const who = added.join(', ');
  const verb = added.length > 1 ? 'dejarán' : 'dejará';
  if (typeof subfolders !== 'number') return `${who} ${verb} de ver esta carpeta y sus subcarpetas.`;
  return `${who} ${verb} de ver esta carpeta y sus ${subfolders} subcarpetas.`;
};
